import { makeAutoObservable } from "mobx";
import { PProductConfigCreator } from "./PProductConfigCreator";
import { PProductError } from "./PProductError";
import { PProductUnavailabilityDetails } from "./PProductInstanceUnavailabilityDetails";
export class PProductInstanceCreatorPart {
    constructor(params) {
        this.domain = params.domain;
        this.possibleProductTypes = params.possibleProductTypes;
        this.productType = params.productType;
        this.partConfigCreator = params.partConfigCreator;
        this.restaurant = params.restaurant;
        makeAutoObservable(this);
    }
    static create(params) {
        const productType = params.restaurant.productTypes.get(params.productTypeId);
        const modifierOrder = productType.divisibleModifiersOrder;
        const partConfigCreator = PProductConfigCreator.create({
            domain: params.domain.productConfigCreator,
            restaurant: params.restaurant,
            localizationProvider: params.localizationProvider,
            modifierOrder,
        });
        return new PProductInstanceCreatorPart({
            domain: params.domain,
            orderingHours: params.orderingHours,
            productType,
            partConfigCreator,
            possibleProductTypes: params.possibleProductTypes,
            restaurant: params.restaurant,
        });
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productName() {
        return this.productType.name;
    }
    get productBaseIngredients() {
        return this.productType.baseIngredients;
    }
    get productTags() {
        return this.productType.tags;
    }
    get productAllergens() {
        return this.productType.allergens;
    }
    get productPhoto() {
        return this.productType.photo;
    }
    get productDescription() {
        return this.productType.description;
    }
    get productFreeModifierItemsCount() {
        return this.productType.freeModifierItemsCount;
    }
    get availability() {
        return this.domain.availability;
    }
    get error() {
        // if (
        //   this.productAvailabilityInfo.type === "Schedule" &&
        //   this.productAvailabilityInfo.available.isDefinitelyFalse
        // ) {
        //   return PProductError.temporarilyUnavailable();
        // }
        const { customParametersDetails, error } = new PProductUnavailabilityDetails({
            availability: this.availability,
            restaurant: this.restaurant,
        });
        if (error === null) {
            return PProductError.none();
        }
        switch (error.type) {
            case "ScheduleUnavailability":
            case "TemporarilyUnavailable":
            case "VisibilityUnavailability":
            case "PreorderUnavailability":
                return PProductError.temporarilyUnavailable();
            case "CustomParametersUnavailability":
            case "InternalParametersUnavailability":
                return PProductError.unavailable(customParametersDetails);
            case "UnknownUnavailability":
                // NOTICE Supress this errors at this particular place
                return PProductError.none();
        }
    }
    touch() {
        this.partConfigCreator.touch();
    }
    get temporarilyUnavailableIngredients() {
        return this.partConfigCreator.temporarilyUnavailableIngredients;
    }
}
